export default function(value){
    return (
        Intl.NumberFormat("en-GB", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value)
        + '%'
    );
}